export enum PrematchStaticCategories {
    FAVORITES = "oblibene",
    MOST_POPULAR = "nejsazenejsi",
}

export const prematchStaticCategoriesNames: { [key in PrematchStaticCategories]: string } = {
    [PrematchStaticCategories.FAVORITES]: "Moje oblíbené",
    [PrematchStaticCategories.MOST_POPULAR]: "Nejsázenější",
};
